/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "y.Berk's Portfolio",
  description:
    "I'm an experienced software engineer who constantly seeks out innovative solutions to everyday problems.",
  og: {
    title: "y.Berk Tarzan Portfolio",
    type: "website",
    url: "https://yberktarzan.github.io/",
  },
};

//Home Page
const greeting = {
  title: "y. Berk Tarzan",
  logo_name: "yberkTarzan",
  nickname: "börü",
  subTitle:
    "I'm an experienced software engineer who constantly seeks out innovative solutions to everyday problems. In my six years in this industry, I've honed my analytical thinking and collaboration skills, and I love working with a team. I've also had the opportunity to serve as the software engineer lead for three projects with Titan Bilişim",
  resumeLink:
    "https://drive.google.com/open?id=1XYpYhLeqCdyx_q6l0bQoC7RgwQjAjXPf",
  portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/yberktarzan",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/yüksel-berk-tarzan-62520a205/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
 
  {
    name: "Gmail",
    link: "mailto:y.berktarzan@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/berk_tarzan",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/berktarzan/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Whatsapp",
    link: "https://wa.me/905342977513",
    fontAwesomeIcon: "fa-whatsapp", // Reference https://fontawesome.com/icons/whatsapp?style=brands
    backgroundColor: "#25D366", // Reference https://simpleicons.org/?q=whatsapp
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Caffe2",
          fontAwesomeClassname: "logos-caffe2",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website w/ admin panel",
        "⚡ Creating application backend in Node & Express",
        "⚡ Database management and API development",
        "// I don't do graphic design! =)",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#777BB4",
          },
        },
        {
          skillName: "Ruby",
          fontAwesomeClassname: "simple-icons:ruby",
          style: {
            color: "#CC342D",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        
      ],
    },
    {
      title: "Esports Organizations",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Creating tournaments and leagues, set up and manage teams from competent people",
        "⚡ Producing API for streamers and manage the broadcast",
        "⚡ Maneging organization communities with my professional team",
      ],
      softwareSkills: [
        {
          skillName: "Riot Games",
          fontAwesomeClassname: "simple-icons:riotgames",
          style: {
            color: "#D32936",
          },
        },
        {
          skillName: "Epic Games",
          fontAwesomeClassname: "simple-icons:epicgames",
          style: {
            color: "#313131",
          },
        },        
      ],
    },
    
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/y_berktarzan",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "ISTANBUL AYDIN UNIVERSITY",
      subtitle: "BE, Software Engineering",
      logo_path: "iaulogo.png",
      alt_name: "IAU",
      duration: "",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like Algorithms, DBMS, OS, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science and Full Stack Development.",
      ],
      website_link: "http://aydin.edu.tr",
    },

  ],
};

const certifications = {
  certifications: [
    {
      title: "MONTESSORİ EĞİTİMİ",
      subtitle: "OMU - ONDOKUZ MAYIS UNIVERSITY",
      logo_path: "omu.png",
      certificate_link:
        "#",
      alt_name: "ONDOKUZ MAYIS UNIVERSITY",
      color_code: "#f1c782",
    },
    {
      title: "Coding and Robotics Instructor Training",
      subtitle: "OMU - ONDOKUZ MAYIS UNIVERSITY",
      logo_path: "omu.png",
      certificate_link:
        "#",
      alt_name: "ONDOKUZ MAYIS UNIVERSITY",
      color_code: "#f1c782",
    },
    {
      title: "Web Development Training (110+ Hours)",
      subtitle: "Udemy - Sadık Turan",
      logo_path: "logo-udemy.svg",
      certificate_link:
        "#",
      alt_name: "Udemy",
      color_code: "#f1c782",
    },
    {
      title: "Traditional Entrepreneurship",
      subtitle: "KOSGEB",
      logo_path: "kosgeb.png",
      certificate_link:
        "#",
      alt_name: "Udemy",
      color_code: "white",
    },
    {
      title: "Advanced Entrepreneurship",
      subtitle: "KOSGEB",
      logo_path: "kosgeb.png",
      certificate_link:
        "#",
      alt_name: "Udemy",
      color_code: "white",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Founder",
          company: "Titan Bilişim Hizmetleri",
          company_url: "https://www.titanbilisim.net/",
          logo_path: "titan-logo.png",
          duration: "2015 - PRESENT",
          location: "Kolektif House, Maslak/Istanbul",
          description:
            "Titan Bilişim Hizmetleri closely follows today's technologies and provides consultancy, design, software and digital marketing services to leading companies in its sector.",
          color: "red",
        },
        {
          title: "Software Engineer - Computer Vision / ML",
          company: "Baykar Technologies",
          company_url: "https://baykartech.com/",
          logo_path: "baykar-logo.jpg",
          duration: "2020",
          location: "Baykar Milli S/İHA Sistemleri Ar-Ge ve Üretim Tesisi, Istanbul",
          description:
            "Computer visison tasks, obtaining digital images to produce digital information, processing and analyzing.",
          color: "blue",
        },
        {
          title: "Co-Founder",
          company: "Alaz Bilişim",
          company_url: "https://www.alazbilisim.com",
          logo_path: "alaz-logo.png",
          duration: "2019 - 2021",
          location: "Work From Home",
          description:
            "Produced software solutions and social media projects in digital media.",
          color: "black",
        },
        
        {
          title: "Senior Developer, Auditor ",
          company: "TGL Turkey Electronic Gaming League A.Ş.",
          company_url: "https:/www.tgleague.org/",
          logo_path: "tgl-siyah.jpg",
          duration: "2021 - PRESENT",
          location: "Work From Home",
          description:
            "Building resposive websites, database management, api development and e-commerce software development. | Risk management, process evaluation, checking and reporting that units are working effectively.",
          color: "orange",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Information Technology Intern",
          company: "Istanbul Aydin University",
          company_url: "https://www.aydin.edu.tr/",
          logo_path: "aydin-logo.jpg",
          duration: "2016",
          location: "Istanbul",
          description:
            "The price has been paid :)",
          color: "blue",
        },
        {
          title: "Data Science Intern",
          company: "Aselsan",
          company_url:
            "https://www.aselsan.com.tr/",
          logo_path: "aselsan.jpg",
          duration: "2016 - 2017",
          location: "Work From Home",
          description:
            "Aselsan provides services on hardware and software development, provision and installation, consultancy and feasibility and current situation analysis together with the necessary team building and training.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Prisident",
          company: "Genç Düşünürler",
          company_url: "https://www.instagram.com/gencdusunurleriau/",
          logo_path: "genc.png",
          duration: "2017 - PRESENT",
          location: "İstanbul",
          description:
            "It is a club founded and managed by me, where I have held events in my high school and university life.",
          color: "black",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2016 - PRESENT",
          location: "Work From Home",
          description:
            "Long live the open source!",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I haven't published any publications yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "yberk.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://yberktarzan.netlify.app",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Maslak, Maslak Mah., Ahi Evran Cd. No:6 D:3, 42, D:B Blok, 34398 Sarıyer/İstanbul",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/1QtM1rQACcJuJcae9",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+90 5342977513",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
